
var set = function (key, value, expire) {
  if (expire === void 0) expire = 3.154e7
  return (document.cookie = (key + '=' + value + ';expires=' + (new Date(Date.now() + expire).toUTCString()) + ';path=/'))
}

var get = function (key) {
  var match = document.cookie.match(new RegExp(key + '=([^;]+)'))
  return match ? match[1] : ''
}

var remove = function (key) {
  return get(key) !== '' && set(key, -1, -1)
}

module.exports = {
  get: get,
  set: set,
  remove: remove
}
